import Config from '../../AppConfig';
import { get } from './core/fetch';

export const getQuickSearchData = async (adviserUUID: string): Promise<any> => {
	return await get(
		`${Config.mlcApiPrefix}/advisers/${adviserUUID}/customers?search=simple`,
		{
			withAuth: true,
			noGateway: false,
		}
	);
};
